// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QjIGk","content":"styles_content__3uJgd","row":"styles_row__2ptV-","footer":"styles_footer__3jkVL","phraseLength":"styles_phraseLength__2mAhP"};